import React, { useContext, useState } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../../utils/context";
import { useForm } from "react-hook-form";

import Offcanvas from "react-bootstrap/Offcanvas";
import Card from "react-bootstrap/Card";
import ModalSave from "../../../common/ModalSave";
import { CancelButton, SaveButton } from "../../../common/Button";
import { Container, Row, Col, Form } from "react-bootstrap";

const AddOffCanvance = (props) => {
  const { postData } = useContext(Context);

  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
    reset,
  } = useForm();

 
  const imageFile = watch("image");

  const onSubmit = async (data) => {
    try {
      const formData = new FormData();
      formData.append("name", data.name);
      // formData.append("status_line", data.status_line);
      // formData.append("sub_name", data.sub_name);
      formData.append("image", data.image[0]);

      const response = await postData("/masters/banner", formData, true);

      setShowModal({
        code: response.code,
        message: response.message,
      });

      if (response.success) {
        reset();
      }

      setTimeout(() => {
        setShowModal({ code: 0, message: "" });
        props.handleClose();
      }, 1000);
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  return (
    <>
      <Offcanvas
        show={props.show}
        style={{ width: "80%" }}
        placement="end"
        onHide={props.handleClose}
      >
        <Offcanvas.Header closeButton />
        <Offcanvas.Body>
          <Card className="shadow-lg p-3 mb-5 bg-white rounded">
            <Card.Body>
              <Card.Title>Add Banner</Card.Title>
              <hr />

              <Container>
                <Form onSubmit={handleSubmit(onSubmit)}>
                  <Row>
                    <Col lg={8} md={10} className="mx-auto Add-content">
                      {/* Banner */}
                      <Row className="mt-4">
                        <Form.Label column sm={3}>
                          Banner
                        </Form.Label>
                        <Col sm={6}>
                          <Form.Control
                            type="text"
                            placeholder="Banner"
                            {...register("name", {
                              required: "Banner is required",
                            })}
                          />
                          {errors.name && (
                            <span className="text-danger">
                              {errors.name.message}
                            </span>
                          )}
                        </Col>
                      </Row>

                      {/* Sub Name */}
                      {/*  <Row className="mt-4">
                        <Form.Label column sm={3}>
                          Sub Name
                        </Form.Label>
                        <Col sm={6}>
                          <Form.Control
                            type="text"
                            placeholder="Sub Name"
                            {...register("sub_name", {
                              required: "Sub name is required",
                            })}
                          />
                          {errors.sub_name && (
                            <span className="text-danger">
                              {errors.sub_name.message}
                            </span>
                          )}
                        </Col>
                      </Row>
                      <Row className="mt-4">
                        <Form.Label column sm={3}>
                          Status Line
                        </Form.Label>
                        <Col sm={6}>
                          <Form.Control
                            type="text"
                            placeholder="Status Line"
                            {...register("status_line", {
                              required: "Status Line is required",
                            })}
                          />
                          {errors.status_line && (
                            <span className="text-danger">
                              {errors.status_line.message}
                            </span>
                          )}
                        </Col>
                      </Row>*/}

                      {/* Image */}
                      <Row className="mt-4">
                        <Form.Label column sm={3}>
                          Image
                        </Form.Label>
                        <Col sm={6}>
                          <Form.Control
                            type="file"
                            accept="image/*"
                            {...register("image", {
                              required: "Image is required",
                            })}
                          />

                          {errors.image && (
                            <span className="text-danger">
                              {errors.image.message}
                            </span>
                          )}

                          {/* ✅ Preview without handleChange */}
                          {imageFile && imageFile[0] && (
                            <div className="mt-3">
                              <img
                                src={URL.createObjectURL(imageFile[0])}
                                alt="preview"
                                style={{
                                  width: "100%",
                                  height: "150px",
                                  objectFit: "cover",
                                  borderRadius: "8px",
                                }}
                              />
                            </div>
                          )}
                        </Col>
                      </Row>

                      {/* Buttons */}
                      <Row className="mt-5 pb-3">
                        <div className="d-flex justify-content-center">
                          <Link>
                            <CancelButton
                              name="cancel"
                              handleClose={props.handleClose}
                            />
                          </Link>

                          <SaveButton name="save" type="submit" />
                        </div>
                      </Row>
                    </Col>
                  </Row>
                </Form>
              </Container>
            </Card.Body>
          </Card>
        </Offcanvas.Body>
      </Offcanvas>

      <ModalSave
        message={showModal.message}
        showErrorModal={!!showModal.code}
      />
    </>
  );
};

export default AddOffCanvance;
